<template>
  <v-layout row justify-center>
    <v-dialog
      transition="slide-y-transition"
      v-model="dialog"
      max-width="400"
      persistent
      @keydown.esc="close"
    >
      <v-card class="confirm-dialog">
        <v-card-title>
          <v-layout align-center justify-space-between class="modal-head-label">
            {{ getDialogLabel() }}
            <v-icon class="svg-icon ml-4" @click="close()">mdi-close</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <h4>{{ getDialogText() }}</h4>
        </v-card-text>
        <v-card-actions>
          <v-layout align-center justify-center class="btns-wrapper mt-4 mb-4">
            <v-btn
              type="button"
              :ripple="false"
              :disabled="isLoading"
              class="warning mb-4"
              depressed
              @click="toggleCompanyStatus()"
            >{{ $t('common.btns.confirm') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'ToggleStatusDialog',
  data() {
    return {
    };
  },
  props: {
    dialog: Boolean,
    investorId: String,
    status: Number,
  },
  computed: {
    ...mapGetters({
      isLoading: 'global/getLoader',
      successAlert: 'global/getAlertSuccess',
    }),
  },
  components: {
  },
  methods: {
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      clearAlertSuccess: 'global/clearAlertSuccess',
      setAlertSuccess: 'global/setAlertSuccess',
      setLoader: 'global/setLoader',
    }),
    ...mapActions({
      changeStatus: 'investor/changeStatus',
    }),
    async toggleCompanyStatus() {
      this.setLoader(true);
      try {
        const response = await this.changeStatus(this.investorId);
        if (response.success) {
          if (response.data.message) {
            const successAlert = {
              state: true,
              message: response.data.message,
            };
            this.clearAlertError();
            this.setAlertSuccess(successAlert);
            this.$emit('update:status', response.data.status);
            this.setLoader(false);
            this.close();
            const that = this;
            setTimeout(() => {
              that.clearAlertSuccess();
            }, 2500);
          }
        } else {
          this.close();
        }
      } catch (error) {
        this.close();
      }
    },
    getDialogLabel() {
      if (this.status === 1) {
        return this.$t('investor.label.deactivationInvestor');
      }
      return this.$t('investor.label.activationInvestor');
    },
    getDialogText() {
      if (this.status === 1) {
        return this.$t('investor.text.deactivationInvestor');
      }
      return this.$t('investor.text.activationInvestor');
    },
    close() {
      this.setLoader(false);
      this.$emit('update:dialog', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-head-label {
  word-break: break-word;
}
h4 {
  text-align: center;
}
</style>
